// extracted by mini-css-extract-plugin
export default {"form":"SignupForm_form__FRGrh","main-heading":"SignupForm_main-heading__hEcyv","divider":"SignupForm_divider__pS+p-"};